import React from 'react';

import ReactPlaceholder from 'react-placeholder';
// import "react-placeholder/lib/reactPlaceholder.css";

import './loadingplaceholder.scss';

class LoadingPlaceholder extends React.Component {
  
    render() {

      let textAlignClass;
      
      switch (this.props['text-align']) {
        case 'left':
          textAlignClass = 'text-left'
          break;
        case 'right':
          textAlignClass = 'text-right'
          break;
        default:
          textAlignClass = 'text-center'
          break;
      }

      const loadingSpinner = (
        <p className={textAlignClass}>
          <i className="fa fa-ellipsis-h fa-2x fa-fw"></i>
        </p>
      );

      return (
        <ReactPlaceholder className="loadingplaceholder-component" ready={this.props.ready} customPlaceholder={loadingSpinner}>
          {this.props.children}
        </ReactPlaceholder>
      );
    }
  }
  
  LoadingPlaceholder.displayName = 'SharedLoadingPlaceholder';
  LoadingPlaceholder.propTypes = {};
  LoadingPlaceholder.defaultProps = {};

  export default LoadingPlaceholder;



// WEBPACK FOOTER //
// ./components/shared/LoadingPlaceholder.js